var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRestaurantes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Restaurantes",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.774,
    height: 54.759,
    viewBox: "0 0 54.774 54.759",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M10.277,12.551H12.2V1.4c0-.771.216-1.4,1.082-1.4s1.082.649,1.071,1.418c0,4.277.032,8.554-.028,12.831A6.136,6.136,0,0,1,11.2,19.642a1.539,1.539,0,0,0-.823,1.537q.03,14.645,0,29.3a10.66,10.66,0,0,1-.078,1.6,3.175,3.175,0,0,1-6.251.087,8.139,8.139,0,0,1-.1-1.489q0-14.81.015-29.619a1.358,1.358,0,0,0-.742-1.359A6.329,6.329,0,0,1,.011,14.021C0,9.85.011,5.681,0,1.512,0,.72.141,0,1.082,0S2.165.733,2.154,1.512V12.493H4.069V1.748C4.069.941,4.03.017,5.128.017s1.1.877,1.082,1.7V12.545H8.132V1.255C8.132.5,8.457-.027,9.251,0c.732.024,1.026.548,1.024,1.247V12.551ZM2.232,14.781a3.98,3.98,0,0,0,2.5,3.279,1.939,1.939,0,0,1,1.407,2.165Q6.084,35.4,6.115,50.575c0,.823-.229,1.838,1.022,2,.79.1,1.1-.513,1.1-2.026q0-15.175-.015-30.351a1.859,1.859,0,0,1,1.325-2.1,4.041,4.041,0,0,0,2.574-3.314Z",
    transform: "translate(0 0.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M216.456,26.808V51.5c0,2.574-2.258,4.216-4.457,3.247a3.164,3.164,0,0,1-1.961-3.149c0-4.762-.024-9.548.022-14.32a2.628,2.628,0,0,0-.894-2.136,9.3,9.3,0,0,1-1.948-2.247,6.747,6.747,0,0,1-.792-2.931c-.076-4.738-.13-9.478,0-14.214a18.465,18.465,0,0,1,7.939-15c.377-.277,1.108-.522,1.409-.34a1.831,1.831,0,0,1,.649,1.4C216.467,10.135,216.456,18.47,216.456,26.808ZM214.314,3.542c-.4.353-.626.524-.82.723a16.549,16.549,0,0,0-4.933,11.6c-.071,3.814-.017,7.63,0,11.444,0,4.448-.387,3.833,2.853,7.1a2.916,2.916,0,0,1,.742,1.859c.061,4.883.032,9.768.035,14.651,0,.32-.108.727.045.944.275.387.688.866,1.082.909.294.032.7-.537.968-.9.121-.162.03-.483.03-.734V13.71Z",
    transform: "translate(-161.684 -0.266)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M86.729,71.391A15.19,15.19,0,1,1,71.563,56.24,15.19,15.19,0,0,1,86.729,71.391ZM71.559,84.469A13.048,13.048,0,1,0,58.494,71.412,13.048,13.048,0,0,0,71.559,84.469Z",
    transform: "translate(-44.152 -44.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M85.221,186.4A21.081,21.081,0,0,1,74.2,183.478c-.649-.394-1.4-.818-.866-1.732s1.245-.571,1.92-.13c.149.1.3.188.459.273a18.171,18.171,0,0,0,16.935.543,17.229,17.229,0,0,0,5.751-4.355c.167-.186.331-.372.489-.565.489-.6,1.061-.918,1.732-.314.608.55.39,1.136-.071,1.693a20.107,20.107,0,0,1-12.16,7.16C87.167,186.268,85.914,186.326,85.221,186.4Z",
    transform: "translate(-57.323 -138.59)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M91.809,32a19.894,19.894,0,0,1,13.385,5.844c.156.147.307.3.448.461a1.072,1.072,0,1,1-1.487,1.543c-.136-.115-.258-.247-.385-.37A18.18,18.18,0,0,0,83.03,35.9l-.292.132c-.63.281-1.216.266-1.561-.4-.381-.742.026-1.227.671-1.545A21.323,21.323,0,0,1,91.809,32Z",
    transform: "translate(-63.491 -25.072)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M60.7,186.329c-.413.264-.866.784-1.232.723-.4-.065-.725-.649-1.082-1.013.361-.355.695-.955,1.082-1s.814.5,1.223.786Z",
    transform: "translate(-45.751 -144.986)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M81.029,92.881a9.84,9.84,0,0,1,5.662-8.442c.7-.351,1.348-.357,1.706.433.342.762-.136,1.182-.773,1.5a7.623,7.623,0,0,0-4.431,6.688c-.056.784-.314,1.383-1.171,1.316S80.975,93.647,81.029,92.881Z",
    transform: "translate(-63.484 -65.984)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M123.881,82.478c-.418.271-.81.7-1.258.775a.837.837,0,0,1-1.011-1.015,1.578,1.578,0,0,1,1.032-1.007c.383-.043.823.483,1.236.76Z",
    transform: "translate(-95.269 -63.646)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurantes);
export default __webpack_public_path__ + "static/media/Restaurantes.e56df2e0e70d63581ce849309bf49b80.svg";
export { ForwardRef as ReactComponent };